import React from 'react';

/**
 * Reusable Page Size Selector Component
 * 
 * @param {Number} pageSize - Current page size value
 * @param {Function} onPageSizeChange - Function to handle page size change (receives event)
 * @param {Array} options - Array of page size options (default: [10, 20, 50, 100])
 * @param {String} label - Label text (default: 'Items per page:')
 * @param {String} className - Additional CSS classes for container
 */
const PageSizeSelector = ({
    pageSize,
    onPageSizeChange,
    options = [2, 10, 20, 50, 100],
    label = 'Items per page:',
    className = '',
}) => {
    const handleChange = (e) => {
        if (onPageSizeChange) {
            onPageSizeChange(e);
        }
    };

    return (
        <div className={`flex items-center gap-2 ${className}`}>
            <label className="text-sm font-medium text-gray-700">{label}</label>
            <select
                value={pageSize}
                onChange={handleChange}
                className="border border-gray-300 rounded px-3 py-1 focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
                {options.map((option) => (
                    <option key={option} value={option}>
                        {option}
                    </option>
                ))}
            </select>
        </div>
    );
};

export default PageSizeSelector;
